<div class="membership-container">
  <div class="coming-soon-section">
    <div class="coming-soon-card">
      <div class="coming-soon-icon">
        <lucide-icon name="clock" [size]="32"></lucide-icon>
      </div>
      <h2 class="coming-soon-title">Coming Soon</h2>
      <p class="coming-soon-description">
        We're working hard to bring you an amazing club membership experience.
        Stay tuned for exclusive access to premium padel facilities!
      </p>
      <div class="coming-soon-features">
        <div class="feature-item">
          <span class="feature-icon"
            ><lucide-icon name="trophy" [size]="20"></lucide-icon
          ></span>
          <span class="feature-text">Premium Club Access</span>
        </div>
        <div class="feature-item">
          <span class="feature-icon"
            ><lucide-icon name="circle-dot" [size]="20"></lucide-icon
          ></span>
          <span class="feature-text">Court Reservations</span>
        </div>
        <div class="feature-item">
          <span class="feature-icon"
            ><lucide-icon name="users" [size]="20"></lucide-icon
          ></span>
          <span class="feature-text">Exclusive Events</span>
        </div>
      </div>
    </div>
  </div>
</div>
